import { render, staticRenderFns } from "./NotificationLink.vue?vue&type=template&id=7d206e14"
import script from "./NotificationLink.vue?vue&type=script&lang=js"
export * from "./NotificationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports